import React from "react";
import BankAccountsTable from "./BankAccountsTable";

const EngineerBankAccount = ({ userId = null }) => {
  return (
    <div>
      <BankAccountsTable userId={userId} />
    </div>
  );
};

export default EngineerBankAccount;
